import { strMatch } from "@mostrans/web-components/helpers/generalHelpers";
import { orderBy } from "lodash";
import { useCallback, useMemo } from "react";
import { useGlobalFilter } from "../../../shared/hooks/useGlobalFilter";
import { useGetEmployeeDemographyAdmin } from "./useGetEmployeeDemographyAdmin";

export const useGetEmployeeDemographyAdminWithFilter = () => {
  const { globalFilter } = useGlobalFilter();
  const [dataDemography, refetch] = useGetEmployeeDemographyAdmin();

  const refetchOnChange = useCallback(() => {
    return refetch();
  }, [refetch]);

  const orderedDemography = useMemo(() => {
    return orderBy(dataDemography.data, (dt) => +dt.id, "desc");
  }, [dataDemography.data]);

  const filteredDemography = useMemo(() => {
    return orderedDemography?.filter((dm) => {
      if (
        globalFilter.search &&
        !strMatch(globalFilter.search, `${dm.demography_name}_${dm.value}`)
      ) {
        return false
      }
      return true
    });
  }, [globalFilter, dataDemography.data]);

  return { dataDemography, refetch, refetchOnChange, filteredDemography };
};
